import React, { useEffect, useRef } from "react";

// Renders a Razorpay hosted subscription button widget.
export default function RazorpayButton({ buttonId, theme = "rzp-dark-standard" }) {
  const formRef = useRef(null);

  useEffect(() => {
    const form = formRef.current;
    if (!form || !buttonId) return;
    if (form.querySelector("script")) return;
    const script = document.createElement("script");
    script.src = "https://cdn.razorpay.com/static/widget/subscription-button.js";
    script.async = true;
    script.setAttribute("data-subscription_button_id", buttonId);
    script.setAttribute("data-button_theme", theme);
    form.appendChild(script);
  }, [buttonId, theme]);

  return <form ref={formRef} data-testid={`rzp-button-${buttonId}`} className="rzp-btn-wrap flex justify-center w-full [&_button]:!w-full" />;
}
